var exports = {
  "He": "contextMenu-aWxJO",
  "lY": "popup-aWxJO",
  "Os": "group-aWxJO",
  "Ry": "quickbar-aWxJO",
  "Iz": "labelHeader-aWxJO",
};

module.exports = exports;
